<template>
  <div id='page-header'>
    <carousel
      id='carousel-element'
      :autoplay='true'
      :nav='false'
      :items=1
      :rewind=true
      :autoplayHoverPause=true 
      :touchDrag=true
    >
      <div class="carousel-content">
        <a href='https://blog.moranow.com/gioi-thieu-04-dich-vu-tren-nen-tang-moranow/' target='blank'>
          <img src="https://zeno-front-moranow.s3-ap-southeast-1.amazonaws.com/page_image/banner-1.jpg">
        </a>        
      </div>      
      <div class="carousel-content">
        <a href="https://blog.moranow.com/03-dieu-chi-co-tai-dich-vu-huong-dan-viet-luan-cua-moranow/" target="blank">
          <img src="https://zeno-front-moranow.s3-ap-southeast-1.amazonaws.com/page_image/banner-2.jpg">  
        </a>        
      </div>
      <div class="carousel-content">
        <a href="https://blog.moranow.com/minh-da-chinh-phuc-06-truong-dai-hoc-top-dau-tai-my-nhu-the-nao/" target="blank">
          <img src="https://zeno-front-moranow.s3-ap-southeast-1.amazonaws.com/page_image/banner-3.jpg">
        </a>        
      </div>
      <div class="carousel-content">
        <a href='https://blog.moranow.com/moranow-giup-gi-cho-cac-ban-apply-muon/' target='blank'>
          <img src="https://zeno-front-moranow.s3-ap-southeast-1.amazonaws.com/page_image/banner-4.jpg">
        </a>        
      </div> 
    </carousel>    
  </div>
</template>
<script>
import Carousel from 'vue-owl-carousel'
import { mapState, mapActions, mapGetters } from 'vuex';
// import { CarouselPlugin, BCarousel, BCarouselSlide } from 'bootstrap-vue';
export default {
  components:{    
    Carousel
  },
  computed:{
    ...mapState( 'user', {
      token: state => state.user.token
    })
  },    
};
</script>
<style lang="scss" scoped>  
  @import "./page_header";  
</style>


// WEBPACK FOOTER //
// src/views/components/HomePage/PageHeader.vue